import { WHITE } from 'constants/colors'

export const styles = theme => ({
  root: {
    display: 'flex',
    position: 'relative',
  },
  button: {
    padding: '8px 16px',
    margin: '0',
    fontSize: 16,
    fontFamily: "'Lato', sans-serif",
    minHeight: 0,
    minWidth: 0,
    background: 'linear-gradient(285.2deg, rgb(90, 152, 247) -35.9%, rgb(22, 88, 243) 61.17%)',
    boxShadow: 'rgb(19 69 186 / 21%) 0px 3px 9px',
    borderRadius: '10px',
    height: '45px',
    color: WHITE,
    fontWeight: 500,
    textTransform: 'none',

    '& svg': {
      marginLeft: 8,

      '& path': {
        stroke: WHITE,
      },
    },
  },
  paper: {
    marginRight: 0,
    zIndex: 15,
  },
  popper: {
    top: '100% !important',
    zIndex: 5,
    width: '100%',
    transform: 'none !important',
  },
  list: {
    padding: 0,
  },
  listItem: {
    fontSize: 14,
  },
  image: {
    width: 34,
    height: 34,
    margin: '12px 12px 12px 0',
    display: 'block',
    borderRadius: '50%',
  },
  pageName: {
    overflow: 'hidden',
    width: 100,
    textOverflow: 'ellipsis',
  },
  tooltip: {
    boxSizing: 'border-box',
    boxShadow: '4px 4px 29px rgba(19, 69, 186, 0.0855129)',
    borderRadius: 10,
    zIndex: 9999,
    opacity: 1,
    textAlign: 'start',
    fontWeight: 'normal',
    padding: 10,
    backgroundColor: '#616581'
  },
})
